<template>
  <div>
    <el-form class="tw-flex tw-justify-between">
      <div class="tw-flex tw-items-center">
        <i-button
          type="white"
          size="large"
          is-icon
          :disabled="!previous"
          @click="() => updateFilter('page', filters.page - 1)"
        >
          <icon-angle-left />
        </i-button>
        <div class="tw-px-5">
          {{ filters.page }}
        </div>
        <i-button
          type="white"
          size="large"
          is-icon
          :disabled="!next"
          @click="() => updateFilter('page', filters.page + 1)"
        >
          <icon-angle-right />
        </i-button>
      </div>

      <div class="tw-mr-8">
        <el-form-item
          label="Rows per pages"
        >
          <el-select
            :model-value="filters.page_size"
            placeholder=""
            @change="(payload) => updateFilter('page_size', payload)"
          >
            <el-option
              v-for="item in [10, 20, 50, 100]"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  // TODO: extract this to global reusable component, because it is used also on the Notification page
  name: 'AdministrationTablePagination',
  props: {
    storePath: {
      type: String,
      required: true,
      default: 'v2/admin/cms/agency/companies',
    },
    filterRelativePath: {
      type: String,
      required: true,
    },
  },
  computed: {
    stateFragment() {
      let statePath = this.$store.state;
      const storePathArray = this.storePath.split('/');

      storePathArray.forEach((path) => {
        statePath = statePath[path];
      });

      return statePath;
    },
    filters() {
      return this.stateFragment[this.filterRelativePath];
    },
    previous() {
      return this.stateFragment.previous;
    },
    next() {
      return this.stateFragment.next;
    },
  },
  methods: {
    updateFilter(field, payload) {
      this.$store.commit(`${this.storePath}/updateFilter`, { field, payload });
    },
  },
};
</script>
